export const keysOfRecoil = {
  native: {
    appVersion: "native-appVersion",
  },
  modal: {
    center: "center",
  },
  PAGE_TITLE: "PAGE_TITLE",
  SIMPLE_QUIZ_INFO: "SIMPLE_QUIZ_INFO",
  SIMPLE_QUIZ_HAIR_LOSS_LEVEL: "SIMPLE_QUIZ_HAIR_LOSS_LEVEL",
  // INTRO
  INTRO_STEP: "INTRO_STEP",
  // COMMON
  APP_BACKGROUND_COLOR: "APP_BACKGROUND_COLOR",
  LOADING_WORKER: "LOADING_WORKER",
  // SCALP
  SCALP_SCANNER_INFO: "SCALP_SCANNER_INFO",
  DIAGNOSIS_ITEMS_STATE: "DIAGNOSIS_ITEMS_STATE",
  // quiz
  QUIZ_OPTION_INFO: "QUIZ_OPTION_INFO",
  IS_VIEW_TRANSITION: "IS_VIEW_TRANSITION",
  QUIZ_REDIRECT_LOCATION: "QUIZ_REDIRECT_LOCATION",
  SCALP_CARE_PRIORITY: "SCALP_CARE_PRIORITY",
  // auth
  MARKETING_AGREEMENT: "MARKETING_AGREEMENT",
};
